<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.account.title' | translate }}
    </h5>
    <div class="buttons">
      <button type="button" class="btn btn-danger"
              (click)="logout()">{{ 'shared.modals.account.buttons.logout' | translate }}</button>
    </div>
  </div>
  <div class="modal-body">
    <ngb-alert [dismissible]="false">
      {{ 'shared.modals.account.description' | translate }}
    </ngb-alert>
    <hr>
    <form [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
      <div class="modal-form-row">
        <label for="account-modal-form-password">
          {{ 'shared.modals.account.form.password.title' | translate }}
        </label>
      </div>
      <div class="modal-form-row">
        <input type="password" class="input small-input" id="account-modal-form-password"
               name="account-modal-form-password"
               [placeholder]="'shared.modals.account.form.password.controls.password.placeholder' | translate"
               [class.error]="passwordForm.dirty && passwordForm.controls.password.errors"
               formControlName="password"
        >
        <input type="password" class="input small-input" id="account-modal-form-repeat" name="account-modal-form-repeat"
               [placeholder]="'shared.modals.account.form.password.controls.repeat.placeholder' | translate"
               [class.error]="passwordForm.dirty && passwordForm.controls.password.errors"
               formControlName="repeat"
        >
      </div>
      <div class="modal-form-row red"
           *ngIf="passwordForm && passwordForm.dirty && passwordForm.controls.password.errors as error">
        <ng-container *ngIf="(error | keyvalue) as keyValue">
          <ng-container *ngIf="keyValue[0] as currentError" [ngSwitch]="currentError.key">
            <ng-container *ngSwitchCase="'required'"></ng-container>
            <ng-container *ngSwitchDefault>{{ 'errors.form.' + currentError.key | translate }}</ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="modal-form-row right">
        <button class="btn btn-success" type="submit" [disabled]="!passwordForm.valid">
          {{ 'shared.modals.account.form.password.buttons.save' | translate }}
        </button>
      </div>
    </form>
    <hr>
    <form [formGroup]="informationForm" (ngSubmit)="submitInformation()">
      <div class="modal-form-row">
        <label for="account-modal-form-password">
          {{ 'shared.modals.account.form.information.title' | translate }}
        </label>
      </div>
      <div class="modal-form-row">
        <input type="text" class="input small-input" id="account-modal-form-username" name="account-modal-form-username"
               [placeholder]="'shared.modals.account.form.information.controls.username.placeholder' | translate"
               [class.error]="informationForm.dirty && informationForm.controls.userName.errors"
               formControlName="userName"
        >
      </div>
      <div class="modal-form-row red"
           *ngIf="informationForm && informationForm.dirty && informationForm.controls.userName.errors as error">
        <ng-container *ngIf="(error | keyvalue) as keyValue">
          <ng-container *ngIf="keyValue[0] as currentError" [ngSwitch]="currentError.key">
            <ng-container *ngSwitchCase="'required'"></ng-container>
            <ng-container *ngSwitchDefault>{{ 'errors.form.' + currentError.key | translate }}</ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="modal-form-row">
        <input type="text" class="input small-input" id="account-modal-form-firstname"
               name="account-modal-form-firstname"
               [placeholder]="'shared.modals.account.form.information.controls.firstname.placeholder' | translate"
               formControlName="firstName"
        >
        <input type="text" class="input small-input" id="account-modal-form-lastname" name="account-modal-form-lastname"
               [placeholder]="'shared.modals.account.form.information.controls.lastname.placeholder' | translate"
               formControlName="lastName"
        >
      </div>
      <div class="modal-form-row right">
        <button class="btn btn-success" type="submit" [disabled]="!informationForm.valid || !informationForm.dirty">
          {{ 'shared.modals.account.form.information.buttons.save' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
            (click)="closeModal()" ngbAutofocus>{{ 'shared.modals.account.buttons.close' | translate }}</button>
  </div>
</div>
